module.exports = __webpack_public_path__ + "assets/f0ddf2483d66ea2a6cb229650158e1e8.mp3";